
import Vue from 'vue';
import store from '@/store';
import { Component, Prop } from 'vue-property-decorator';
import { NavLink } from '@/models/types';
import { UserIdentityModel } from '@/models/file-entities.model';
import { ViewType } from '@/models/file-enum.model';
import { moduleAccessByRole } from '@/utils/Permissions';

@Component({
  name: 'RepsolNavBarComponent'
})

export default class RepsolNavBarListComponent extends Vue {
  @Prop()
  public navLinks!: NavLink[];
  @Prop({
    type: Boolean,
    default: false
  })
  public bottom!: boolean;
  @Prop()
  public icons!: boolean;

  public userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;

  private navigateTo(navLink: NavLink) {
    navLink.isExternal ? window.open(navLink.path, '_blank') : this.$router.push(navLink.path);
  }

  private highlightNavLink(navLink: NavLink): boolean {
    const routePath = this.$route.path.split('/');
    let bRetval = false;
    if (navLink) {
      for (const item of routePath) {
        if (navLink.path.replace('/', '').toLowerCase() === item.toLowerCase()) {
          bRetval = true;
          break;
        }
      }
    }
    return bRetval;
  }

  // Roles Management For Module
  public roleManagementForModule(moduleName: string): boolean {
    if (moduleName === ViewType.Help) {
      return true;
    }
    return moduleAccessByRole(this.userIdentity.modulos, moduleName);
  }
}

Vue.component('repsol-nav-bar-list', RepsolNavBarListComponent);
